import { Config } from '@/config';
import { ApiService } from '@/services/api.service';
import axios from 'axios';

const CancelToken = axios.CancelToken;
let cancelToken = null;

class OpportunityLabelsService {
  getOpportunityLabels() {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.get(`${Config.api.document.url}api/v1/opportunity-labels`, {
      cancelToken: cancelToken.token,
    }).then((response) => response.data);
  }
  getOpportunityLabel(opportunityLabelId) {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.get(`${Config.api.document.url}api/v1/opportunity-labels/${opportunityLabelId}`, {
      cancelToken: cancelToken.token,
    }).then((response) => response.data);
  }
  addOpportunityLabel(opportunityLabel) {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.post(`${Config.api.document.url}api/v1/opportunity-labels`, opportunityLabel, {
      cancelToken: cancelToken.token,
    }).then((response) => response.data);
  }
  editOpportunityLabel({ opportunityLabelId, opportunityLabel }) {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.put(
      `${Config.api.document.url}api/v1/opportunity-labels/${opportunityLabelId}`,
      opportunityLabel,
      {
        cancelToken: cancelToken.token,
      },
    ).then((response) => response.data);
  }
  deleteOpportunityLabel(opportunityLabelId) {
    if (cancelToken) {
      cancelToken.cancel('Multiple requests.');
    }
    cancelToken = CancelToken.source();

    return ApiService.delete(`${Config.api.document.url}api/v1/opportunity-labels/${opportunityLabelId}`, {
      cancelToken: cancelToken.token,
    }).then((response) => response.data);
  }
}

const opportunityLabelsService = new OpportunityLabelsService();

export default opportunityLabelsService;
